import MobileTableRow from './MobileTableRow';

export default MobileTableRow;
